import {createSelector} from 'reselect';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import {getTripData} from './store';

// Returns number of nights between arrive/depart dates
const getTripNights = createSelector(
    [getTripData],
    (tripData) => {
        const {arriveDateText, departDateText} = tripData;

        return differenceInCalendarDays(new Date(departDateText), new Date(arriveDateText)) || 0;
    }
);

export {getTripNights};
